import React from 'react';
import { Button, Modal } from 'antd';
import { t } from 'i18next';
import { GetClientType } from "../../../config";
import {useSelector} from "react-redux";
import {notification} from "antd";
const AddToProjectSection = ({ profileType, browser, selectedProduct }) => {

    const lang = localStorage.getItem('lang')

     const license = useSelector((state) => state?.profile?.profileData?.license);
    const notificationDirection = lang === 'fa' || lang === 'ar' ? 'rtl' : 'ltr';

    const handleRender = async (renderFunction) => {
        console.log(license);
        
        try {
            if ((license?.is_expired || !license) && !selectedProduct.is_free) {
                notification.error({
                    message: t('download.login_alert_title_download'),
                    description: t('download.free_alert_decription_download'),
                    placement: "topRight",
                    style: { direction: notificationDirection }
                });
                return
            }
            const renderStatus = await browser[renderFunction](selectedProduct); 
            if(GetClientType() == "3dmax") {
                if (renderStatus !== true) {
                    Modal.error({
                        title: t("messages.error"),
                        content: renderStatus,
                    });
                }
            }         
           
        } catch (error) {
            console.error(`Error executing ${renderFunction}:`, error);
            Modal.error({
                title: t("messages.error"),
                content: t("messages.execution_failed"),
            });
        }
    };

    const renderButtons = (buttons) => (
        <div className='buttons'>
            {buttons.map(({ key, label, action, fullWidth }) => (
                <Button key={key} style={fullWidth ? { width: "100%" } : {}} onClick={() => handleRender(action)}>
                    {t(label)}
                </Button>
            ))}
        </div>
    );

    if (GetClientType() === "3dmax") {
        if (profileType === "sweep_maker") {
            return (
                <div className='add-to-project'>
                    <div className='title'>{t('download.first_select_line')}</div>
                    {renderButtons([{ key: 'addToLine', label: 'download.add_to_line', action: 'addToLine', fullWidth: true }])}
                </div>
            );
        }
        if (profileType == "all" || profileType == "object") {
            return (
                <div className='add-to-project'>
                    <div className='title'>{t('download.add_to_project')}</div>
                    {renderButtons([
                        { key: 'vray', label: 'product.vray', action: 'vray' },
                        { key: 'corona', label: 'product.corona', action: 'corona' },
                    ])}
                </div>
            );
        }
        if (profileType == "texture") {
            return (
                <div className='add-to-project'>
                    <div className='title'>{t('download.add_to_project')}</div>
                    {renderButtons([
                        { key: 'vrayTexture', label: 'product.vray', action: 'vrayTexture' },
                        { key: 'coronaTexture', label: 'product.corona', action: 'coronaTexture' },
                    ])}
                </div>
            );
        }
    }

    // Revit-Specific Actions
    if (GetClientType() === "revit") {
        if (profileType == "object") {
        return (
            <div className='add-to-project'>
                <div className='title'>{t('download.add_to_project')}</div>
                {renderButtons([
                    { key: 'appAddToObject', label: 'download.add_to_project', action: 'appAddToObject', fullWidth: true },
                ])}
            </div>
        );
    }
        return (
            <div className='add-to-project'>
                <div className='title'>{t('download.add_to_project')}</div>
                {renderButtons([
                    { key: 'appApplyMaterial', label: 'download.add_to_object', action: 'appApplyMaterial', fullWidth: true },
                ])}
            </div>
        );
    }
    if (GetClientType() === "unreal_engine") {
     
        return (
            <div className='add-to-project'>
                <div className='title'>{t('download.add_to_project')}</div>
                {renderButtons([
                    { key: 'addToProject', label: 'download.add_to_project', action: 'addToProject', fullWidth: true },
                ])}
            </div>
        );
    }
    return (
        <div className='add-to-project'>
            <div className='title'>{t('download.add_to_project')}</div>
            {renderButtons([{ key: 'addToProject', label: 'download.add_to_project', action: 'addToProject', fullWidth: true }])}
        </div>
    );
};

export default AddToProjectSection;
